import { createReducer, on, createFeature } from '@ngrx/store'
import {
  blockEmployee,
  blockEmployeeFailure,
  blockEmployeeSuccess,
  deleteEmployee,
  deleteEmployeeFailure,
  deleteEmployeeSuccess,
  loadEmployeeByIdFailure,
  loadEmployeeByIdSuccess,
  loadEmployees,
  loadEmployeesFailure,
  loadEmployeesSuccess,
  loadUserFailure,
  loadUsers,
  loadUsersSuccess,
  updateEmployeeFailure,
  updateEmployeeSuccess,
  loadUserByIdSuccess,
  resetEmployeeState,
  portalAccessEmployee,
  portalAccessEmployeeSuccess,
  portalAccessEmployeeFailure,
  resetUserState
} from './user.actions'
import { UserState } from './user.state'

const initialState: UserState = {
  users: [],
  loading: false,
  error: null,
  selectedUser: null,
  totalCount: 0,
  activeCount: 0,
  inactiveCount: 0,
  newJoineeCount: 0
}

export const userReducer = createReducer(
  initialState,
  on(loadUsers, state => ({ ...state, loading: true })),
  on(loadUsersSuccess, (state, { users }) => ({
    ...state,
    users,
    loading: false,
    error: null
  })),

  // this code is added by SHIVAM
  on({ type: '[Auth] Update User' } as any, (state, action: any) => ({
    ...state,
    user: action.user
  })),
  // Single User Loading
  on(loadUserByIdSuccess, (state, { user }) => ({
    ...state,
    selectedUser: user,
    loading: false,
    error: null
  })),
  on(loadUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(loadEmployees, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(
    loadEmployeesSuccess,
    (state, { totalCount, activeCount, inactiveCount, newJoineeCount, employees }) => ({
      ...state,
      totalCount,
      activeCount,
      inactiveCount,
      newJoineeCount,
      users: employees,
      loading: false,
      error: null
    })
  ),
  on(loadEmployeesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(blockEmployee, (state, { id }) => ({
    ...state,
    users: state.users.map(user => (String(user.id) === id ? { ...user, disabled: true } : user))
  })),
  on(blockEmployeeSuccess, (state, { user }) => {
    // console.log('reducer called')
    // Update the business state to reflect that it is blocked
    const updatedState = {
      ...state,
      users: state.users.map(
        b => {
          if (b.id === user.id) {
            // console.log('updated user', { ...b, ...user })
            return { ...b, ...user }
          } else return b
        } // Update the business object
      ),
      error: null
    }
    return updatedState
  }),
  on(blockEmployeeFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(deleteEmployee, (state, { id }) => ({
    ...state,
    users: state.users.map(user => (String(user.id) === id ? { ...user, disabled: true } : user))
  })),
  on(deleteEmployeeSuccess, (state, { id }) => {
    // Update the business state to reflect that it is successfully deleted
    const updatedState = {
      ...state,
      users: state.users.filter(b => b.id !== id), // Remove the business from the list
      error: null
    }
    return updatedState
  }),
  on(deleteEmployeeFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(loadEmployeeByIdSuccess, (state, { user }) => ({
    ...state,
    user,
    error: null
  })),
  on(loadEmployeeByIdFailure, (state, { error }) => ({
    ...state,
    user: null,
    error
  })),
  on(updateEmployeeSuccess, (state, { user }) => ({
    ...state,
    user,
    error: null
  })),
  on(updateEmployeeFailure, (state, { error }) => ({
    ...state,
    error
  })),
  // on(resetEmployeeState, () => initialState),
  on(resetEmployeeState, state => ({
    ...state,
    employees: [], // clear previous data immediately
    totalCount: 0,
    loading: false
  })),
  on(portalAccessEmployee, (state, { id }) => ({
    ...state,
    users: state.users.map(user =>
      String(user.id) === id ? { ...user, portalAccess: true } : user
    )
  })),
  on(portalAccessEmployeeSuccess, (state, { user }) => {
    // console.log('reducer called')
    // Update the business state to reflect that it is blocked
    const updatedState = {
      ...state,
      users: state.users.map(
        b => {
          if (b.id === user.id) {
            // console.log('updated user', { ...b, ...user })
            return { ...b, ...user }
          } else return b
        } // Update the business object
      ),
      error: null
    }
    return updatedState
  }),
  on(portalAccessEmployeeFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(resetUserState, () => initialState)
)

export const userFeature = createFeature({
  name: 'user',
  reducer: userReducer
})
export type { UserState }

export const {
  name,
  reducer,
  selectUsers,
  selectSelectedUser,
  selectLoading,
  selectError,
  selectUserState,
  selectActiveCount,
  selectInactiveCount,
  selectNewJoineeCount,
  selectTotalCount
} = userFeature
